const guiColors = {
    'motion-primary': 'oklab(0.42 -0.01 -0.08)',
    'motion-primary-transparent': 'oklab(0.42 -0.01 -0.08 / 0.8)',
    'motion-tertiary': 'oklab(0.37 0.01 -0.07)',

    'looks-secondary': 'oklab(0.37 0.01 -0.07)',
    'looks-transparent': 'oklab(0.37 0.01 -0.07 / 0.6)',
    'looks-light-transparent': 'oklab(0.37 0.01 -0.07 / 0.3)',
    'looks-secondary-dark': 'oklab(0.30 0.02 -0.04)',

    'extensions-primary': 'oklab(0.30 0.02 -0.04)',
    'extensions-tertiary': 'oklab(0.30 0.02 -0.04 / 0.8)',
    'extensions-transparent': 'oklab(0.30 0.02 -0.04 / 0.35)',
    'extensions-light': 'oklab(0.42 -0.01 -0.08 / 0.9)',

    'drop-highlight': 'oklab(0.37 0.01 -0.07)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.42 -0.01 -0.08 / 0.4) 0%, ' +
        'oklab(0.37 0.01 -0.07 / 0.4) 50%, ' +
        'oklab(0.30 0.02 -0.04 / 0.4) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.42 -0.01 -0.08)',
    checkboxActiveBorder: 'oklab(0.37 0.01 -0.07)'
};

export {
    guiColors,
    blockColors
};
